module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "persistent": "",
      "width": "480px"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline py-2 px-5"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "text-xs-left": ""
    }
  }, [_c('p', {
    staticClass: "headline-title"
  }, [_vm._v("\n\t\t\t\t\t\tAnulación de reserva\n\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "text-xs-right": ""
    }
  }, [_c('label', {
    staticClass: "headline-label"
  }, [_vm._v("\n\t\t\t\t\t\tFecha:\n\t\t\t\t\t")]), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.today) + "\n\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-5"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Motivo")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    model: {
      value: (_vm.cancelModel.title),
      callback: function($$v) {
        _vm.cancelModel.title = $$v
      },
      expression: "cancelModel.title"
    }
  }), _vm._v(" "), (_vm.$v.cancelModel.title && _vm.$v.cancelModel.title.$invalid) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\t\t\t\tEl motivo de anulación es requerido\n\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-3": ""
    }
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Descripción")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset input-textarea input-note",
    attrs: {
      "no-resize": "",
      "multi-line": "",
      "rows": 3,
      "textarea": ""
    },
    model: {
      value: (_vm.cancelModel.description),
      callback: function($$v) {
        _vm.cancelModel.description = $$v
      },
      expression: "cancelModel.description"
    }
  }), _vm._v(" "), (_vm.$v.cancelModel.description && _vm.$v.cancelModel.description.$invalid) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\t\t\t\tLa descripción de la anulación es requerida\n\t\t\t\t\t")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "pr-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-cancel grey",
    nativeOn: {
      "click": function($event) {
        _vm.closeCancelModal($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tCancelar\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "pl-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-save",
    attrs: {
      "disabled": _vm.$v.$invalid
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelBooking($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tAceptar\n\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cd2da4d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/bookings/sub-component/MenuCancelBooking.vue
// module id = 1608
// module chunks = 21